import React from 'react';

// import components
import NavItem from './NavItem';

// import styled components
import { Grid } from '../../styled';
import { NavContainer } from './styled';

const Nav = () => (
  <NavContainer role="navigation">
    
    <Grid>
      <ul>
        <NavItem target="about" label="About" />
        <NavItem target="team" label="Meet the Team" />
        <NavItem target="getintouch" label="Get in Touch" />
        <NavItem target="loanprograms" label="Loan Programs" />
        <NavItem target="constroadmap" label="Construction Road Map" />
      </ul>
    </Grid>
  </NavContainer>
);

export default Nav;
